var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main-container"},[_c('br'),_c('tl-tabs',{staticClass:"margintop-20",attrs:{"tabs":_vm.tabs,"customclass":true},on:{"changeTab":function($event){return _vm.onTabChange()}}},[_c('tl-tab',[_c('add-exit-employees')],1),_c('tl-tab',[_c('exiting-employees-list',{attrs:{"empList":_vm.employeeData}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }